import React from 'react';

const Login: React.FC = () => {
  const handleLogin = () => {
    // Redirect to backend for Spotify OAuth
    window.location.href = '/auth/spotify';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#191414',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    }}>
      <div style={{
        maxWidth: '480px',
        width: '90%',
        textAlign: 'center',
        padding: '48px 40px',
        background: '#282828',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      }}>
        <h1 style={{ margin: '0 0 8px', fontSize: '36px', color: '#1DB954', letterSpacing: '-0.5px' }}>
          Spotlist
        </h1>
        <p style={{ margin: '0 0 32px', fontSize: '14px', color: '#aaa', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
          Predicted Setlist Creator
        </p>

        <p style={{ margin: '0 0 24px', fontSize: '16px', color: '#e0e0e0', lineHeight: 1.6 }}>
          Spotlist analyses recent concert setlists for any artist and predicts what they're likely to play next. Connect your Spotify account to build and save a playlist of those predicted songs in seconds.
        </p>

        <ul style={{
          listStyle: 'none',
          margin: '0 0 36px',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          textAlign: 'left',
        }}>
          {[
            { icon: '🔍', text: 'Search any artist and choose how many recent setlists to analyse' },
            { icon: '🎵', text: 'See a predicted setlist ranked by how often each song appears' },
            { icon: '✅', text: 'Pick the songs you want and reorder them to your liking' },
            { icon: '🚀', text: 'Save the playlist directly to your Spotify library' },
          ].map(({ icon, text }) => (
            <li key={text} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', color: '#ccc', fontSize: '14px', lineHeight: 1.5 }}>
              <span style={{ fontSize: '18px', flexShrink: 0 }}>{icon}</span>
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={handleLogin}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            padding: '14px 32px',
            fontSize: '16px',
            fontWeight: 700,
            backgroundColor: '#1DB954',
            color: '#000',
            border: 'none',
            borderRadius: '50px',
            cursor: 'pointer',
            letterSpacing: '0.5px',
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.494 17.278a.75.75 0 0 1-1.032.244c-2.826-1.726-6.386-2.116-10.578-1.16a.75.75 0 0 1-.334-1.462c4.584-1.047 8.515-.596 11.7 1.346a.75.75 0 0 1 .244 1.032zm1.467-3.262a.937.937 0 0 1-1.29.308c-3.233-1.987-8.158-2.563-11.984-1.403a.938.938 0 0 1-.578-1.787c4.37-1.315 9.8-.678 13.544 1.592a.938.938 0 0 1 .308 1.29zm.126-3.396C15.422 8.39 9.29 8.18 5.88 9.215a1.124 1.124 0 0 1-.693-2.144c3.98-1.287 10.595-1.038 14.77 1.524a1.125 1.125 0 0 1-1.87 1.025z"/>
          </svg>
          Log in with Spotify
        </button>
      </div>
    </div>
  );
};

export default Login;
